// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonControl_wrapper__HJURV","button":"ButtonControl_button__-2bos","active":"ButtonControl_active__YsmGc"};